<template>

        <v-combobox 
        dense 
        v-model="department"
        :items="departamentos"
        @change="selectDepartment">
        
        </v-combobox>
        

        <!--<sui-dropdown :text="dataDepartment.departmentName">
            <sui-dropdown-menu >
                <template v-for="(dep,index) in departamentos">
                    <sui-dropdown-item @click="selectDepartment(dep.id)" :key="index">{{dep.Nombre}}</sui-dropdown-item>
                </template>
            </sui-dropdown-menu>
        </sui-dropdown>-->
</template>

<style scoped>
    .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    }
</style>


<script>
//const $ = require('jquery');
//window.$ = $;

//import moment from 'moment'


export default {
  name: 'SelectedDepartment',
  components: {
  },
  props: [],
  data() {
    return {
       departmentName:'',
       department:'',
       departamentoSeleccionado:'',
    }
  },
  methods: {
     selectDepartment(){
        
         localStorage.setItem("selectedDepartment",this.department.id);
         //this.departmentName = this.$uvHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre
         this.$router.go()
     }
  },
  computed:{
      departamentos(){
          
          let departamentos = this.$store.getters.getDepartamentos;
          departamentos.forEach((dep)=>{
              dep.text= dep.Nombre,
              dep.value=dep.id
          });
          return departamentos;
      },
      dataDepartment(){
          let department = "";
          let departmentName = "";
          if(localStorage.getItem("selectedDepartment")){
           department = localStorage.getItem("selectedDepartment");
           departmentName = this.$uvHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre
          }else{
                localStorage.setItem("selectedDepartment",this.$store.getters.getIdDepartamentos.Golf);
                department = this.$store.getters.getIdDepartamentos.Golf;
                departmentName = this.$uvHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre
          } 
          return {department:department,departmentName:departmentName}
      }
  },
  watch:{
       
  },
  beforeMount: function() {
        
  },
  mounted(){
     if(localStorage.getItem("selectedDepartment")){
           this.department = localStorage.getItem("selectedDepartment");
           this.departmentName = this.$uvHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre
     }else{
            localStorage.setItem("selectedDepartment",this.$store.getters.getIdDepartamentos.Golf);
            this.department = this.$store.getters.getIdDepartamentos.Golf;
            this.departmentName = this.$uvHelper.getById(this.departamentos,'id',localStorage.getItem("selectedDepartment")).Nombre

     }  
  }
 
}
</script>